/* brand-footer — "tonight" satırını tarayıcıda kesin astronomik hesapla tazeler (U03).
   Sunucu (Liquid) render anındaki evreyi basar; sayfa önbelleği bayatsa burada düzeltilir. Ağ isteği yok, global yok.
   Hesap: referans yeni ay 2000-01-06 18:14 UTC, sinodik ay 29.530588853 gün; aydınlık oran = (1 - cos 2πa) / 2.
   Glif: yalnız sözleşmedeki evre geometrisi (viewBox "-12 -12 24 24", r 10.4) varsa aydınlık yol güncellenir;
   yoksa ve evre değiştiyse glif gizlenir (metin her zaman doğru kalır). */
(function () {
  'use strict';
  var SYN = 29.530588853;
  var REF = Date.UTC(2000, 0, 6, 18, 14);
  var R = 10.4;

  function litPath(k) {
    var rx = (Math.abs(1 - 2 * k) * R).toFixed(2);
    var sweep = k > 0.5 ? 1 : 0;
    return 'M0 -' + R + 'A' + R + ' ' + R + ' 0 0 1 0 ' + R + 'A' + rx + ' ' + R + ' 0 0 ' + sweep + ' 0 -' + R + 'Z';
  }

  function refresh(root) {
    var names = (root.getAttribute('data-names') || '').split('|');
    var tpl = root.getAttribute('data-template') || '';
    if (names.length !== 8 || !tpl) return;

    var age = (((Date.now() - REF) / 864e5) % SYN + SYN) % SYN;
    var a = age / SYN;
    var illum = (1 - Math.cos(2 * Math.PI * a)) / 2;
    var pct = Math.round(illum * 100);
    var idx = Math.round(a * 8) % 8;
    var k8 = Math.round(pct * 8 / 100);
    var waning = a >= 0.5;

    var sPct = parseInt(root.getAttribute('data-pct'), 10);
    var sIdx = parseInt(root.getAttribute('data-idx'), 10);
    var sK8 = parseInt(root.getAttribute('data-k8'), 10);
    var sWane = root.getAttribute('data-waning') === 'true';
    if (Math.abs(pct - sPct) <= 1 && idx === sIdx && k8 === sK8 && waning === sWane) return;

    var text = root.querySelector('.brand-footer__tonight-text');
    if (text) {
      text.textContent = tpl.split('[phase]').join(names[idx].trim()).split('[percent]').join(String(pct));
    }
    var phase = root.querySelector('.brand-footer__phase');
    if (!phase) return;
    phase.classList.toggle('is-waning', waning);
    if (k8 === sK8) return;
    var svg = phase.querySelector('svg[viewBox="-12 -12 24 24"]');
    var lit = svg ? svg.querySelector('path') : null;
    if (lit && k8 > 0 && k8 < 8) {
      lit.setAttribute('d', litPath(k8 / 8));
    } else {
      phase.hidden = true;
    }
  }

  function run() {
    var nodes = document.querySelectorAll('[data-brand-component="footer-tonight"]');
    for (var i = 0; i < nodes.length; i++) refresh(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
